module.exports = __webpack_public_path__ + "btd_header.jpg?ac7faaa97adfb97e703a3db0249668f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btd_header.jpg
// module id = 896
// module chunks = 0